import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const PrnBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-primary bg-transparent text-primary">
      {t('component:badge.prn')}
    </Badge>
  );
};
